import type {
  IErrorResponse,
  SignUpOTPRequest,
  SignUpOTPResponse,
} from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';

const useSignUpOtp = (): UseMutationResult<
  SignUpOTPResponse,
  IErrorResponse,
  SignUpOTPRequest
> => {
  const { t } = useTranslation('messages');

  return useMutation({
    mutationFn: (data) => api.post(urls.signUpOtp, data),
    onSuccess() {
      standaloneToast({
        status: 'success',
        title: t('sendToCode'),
      });
    },
  });
};

export default useSignUpOtp;
